import isObject from 'lodash/isObject';
import PlanFuel from './plan-fuel';

/**
 * @property {bool} isRecommended
 * @property {string} tagline
 * @property {string} title
 * @property {string} bonusOffer
 * @property {string} exitFees
 * @property {string} benefitPeriod
 * @property {string} accountManagement
 * @property {string} termsAndConditions
 * @property {Array.<PlanFuel>} fuels
 */
export default class Plan {
  /**
   * @param {Object.<string, string>} props - properties to own upon instantiation
   */
  constructor(props) {
    Object.assign(this, props);
  }

  /**
   * Create a new `Plan` instance. The properties in `instanceSeed`
   * will be shallow-merged as properties of the new instance.
   *
   * @param {Object} instanceSeed
   * @return {Plan}
   */
  static create(instanceSeed) {
    if (!instanceSeed) {
      throw new ReferenceError('missing required argument instanceSeed');
    }

    if (isObject(instanceSeed) === false) {
      throw new TypeError('argument instanceSeed was not of required type "Object"');
    }

    return new this(instanceSeed);
  }

  /**
   * @param {Object} rawInstance
   * @returns {Plan}
   */
  static createFromServerFormat(rawInstance) {
    if (!rawInstance) {
      throw new ReferenceError('missing required argument rawInstance');
    }

    if (isObject(rawInstance) === false) {
      throw new TypeError('argument rawInstance was not of required type "Object"');
    }

    const newInstance = Plan.create({
      isRecommended: rawInstance.isRecommended,
      tagLine: rawInstance.tagLine,
      title: rawInstance.title,
      bonusOffer: rawInstance.bonusOffer,
      exitFees: rawInstance.exitFees,
      benefitPeriod: rawInstance.benefitPeriod,
      accountManagement: rawInstance.accountManagement,
      termsAndConditions: rawInstance.termsConditions,
      fuels: rawInstance.fuel.map(PlanFuel.createFromServerFormat.bind(PlanFuel)),
    });
    return newInstance;
  }
}
